import React from 'react';

export const TextContext = React.createContext();
